import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { IconButton, Grid, Menu, MenuItem, ListItemIcon, Typography } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import HistoryIcon from '@mui/icons-material/History';
import SearchHistoryDialog from './SearchHistoryDialog';
import CusSnackbar from '../CusSnackbar';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.paper,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	}
}));

export default function SearchHistory({
	mySearchHistory,
	handleSearchHistory,
	saveSearchHistory,
	saveBookmarks,
	bookmarks
}) {
	const [anchorEl, setAnchorEl] = useState(null);
	const [open, setOpen] = useState(false);
	const [option, setOption] = useState('');
	const [snack, setSnack] = useState({ message: '', severity: 'success' });

	const handleCloseSnack = () => {
		setSnack({ message: '', severity: 'success' });
	};

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleOpenBookmark = () => {
		setOption('bookmark');
		setOpen(true);
		setAnchorEl(null);
	};

	const handleOpenSearchHistory = () => {
		setOption('history');
		setOpen(true);
		setAnchorEl(null);
	};

	return (
		<React.Fragment>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
				onClick={handleClick}
				size="large"
			>
				<MoreVertIcon />
			</IconButton>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				<MenuItem onClick={handleOpenBookmark}>
					<ListItemIcon>
						<BookmarkBorderOutlinedIcon fontSize="small" />
					</ListItemIcon>
					<Typography variant="inherit">My Saved Searches</Typography>
				</MenuItem>
				<MenuItem onClick={handleOpenSearchHistory}>
					<ListItemIcon>
						<HistoryIcon fontSize="small" />
					</ListItemIcon>
					<Typography variant="inherit">My Search History</Typography>
				</MenuItem>
			</Menu>
			<SearchHistoryDialog
				mySearchHistory={mySearchHistory}
				handleSearchHistory={handleSearchHistory}
				saveSearchHistory={saveSearchHistory}
				saveBookmarks={saveBookmarks}
				bookmarks={bookmarks}
				selectOption={option}
				open={open}
				setOpen={setOpen}
				onSuccess={(message) => setSnack({ message, severity: 'success' })}
				onDelete={(message) => setSnack({ message, severity: 'error' })}
				onError={(message) => setSnack({ message, severity: 'error' })}
			/>
			{snack.message && (
				<CusSnackbar
					message={snack.message}
					severity={snack.severity}
					onClose={handleCloseSnack}
				/>
			)}
		</React.Fragment>
	);
}
